import React from 'react';
import { Link } from 'react-router-dom';
import { ArrayHelpers, DomHelpers, Paging, SystemText } from 'e4shared';
import BlobImage from 'components/blobImage';
import { useSelector } from 'react-redux';
import { apiGet } from 'services';
import WidgetBase from 'views/myDashboard/components/widgets/_base';
import { e4Format, e4Formats } from 'helpers/dates';

export const LatestBlogPosts = ({ history, item }) => {
    const loaded = React.useRef(null);
    const [loading, setLoading] = React.useState(true);
    const [data, setData] = React.useState([]);
    const [pagedData, setPagedData] = React.useState([]);
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(6);
    const recordCount = data.length;
    const rowHeight = 120;
    const extrasHeight = 50;

    const user = useSelector(state => state.user.user);

    React.useEffect(() => {
        apiGet(`blog-home`, user.guid, response => {
            setData(response.posts);
            setLoading(false);
        });
    }, []);

    React.useEffect(() => {
        !loading && loaded.current && DomHelpers.truncateText('widget-blog-title', loaded.current, 0);
    }, [loading, loaded.current, item.w, page]);

    React.useEffect(() => {
        setPagedData(ArrayHelpers.getPage(data, page, pageSize));
    }, [page]);

    React.useEffect(() => {
        const pageSizeGenerator = () => {
            const thisHeight = 110 * item.h - 50;
            let result = Math.ceil((thisHeight - extrasHeight) / rowHeight, 0);
            if (result < recordCount) result--;
            return result < 1 ? 1 : result;
        };

        const ps = pageSizeGenerator();
        setPagedData(ArrayHelpers.getPage(data, 1, ps));
        setPage(1);
        setPageSize(ps);
    }, [loaded.current, data, item.h, recordCount]);

    const goTo = (event, link) => {
        event.cancelBubble = true;
        if (event.stopPropagation) event.stopPropagation();
        history.push(link);
    };

    const text = {
        by: SystemText('Home/Widgets/Posts/By'),
        noPosts: SystemText('Home/Widgets/Posts/NoPosts'),
        blog: SystemText('Home/Widgets/Posts/GetBlogging'),
    };

    const chart = (
        <div ref={loaded}>
            {data.length === 0 ? (
                <div>
                    <p>{text.noPosts}</p>
                    <Link to="/blog">
                        <button className="mt20 btn btn-primary">{text.blog}</button>
                    </Link>
                </div>
            ) : (
                <div className="mtm10">
                    {pagedData.map((post, i) => {
                        return (
                            <div
                                key={`post-${post.id}-${i}`}
                                className="pt10"
                                style={{ height: `${rowHeight}px`, borderBottom: 'solid 1px #ebebeb' }}
                            >
                                <div className="text-lg mb5">
                                    <Link to={`/blog/post/${post.id}`} className="btn-link" title={post.title}>
                                        <div className="widget-blog-title ellipse">{post.title}</div>
                                    </Link>
                                </div>
                                <div className="flex">
                                    <div
                                        style={{ width: '100px' }}
                                        className="mr10"
                                        onClick={e => goTo(e, `/blog/post/${post.id}`)}
                                    >
                                        <BlobImage
                                            key={`post_${post.blog_Image}`}
                                            alt=""
                                            folder="blog_Image"
                                            src={post.blog_Image}
                                        />
                                    </div>
                                    <div className="flex-grow">
                                        <div className="text-sm">
                                            {text.by}{' '}
                                            <button className="btn-link" onClick={e => goTo(e, `/blog/${post.owner_Id}`)}>
                                                {post.owner_Full_Name}
                                            </button>
                                            <div className="text-sm">{e4Format(post.date, e4Formats.longWithDay)}</div>
                                        </div>
                                        <div className="text-sm">
                                            <span className="mr10">
                                                <i className="fa fa-comments" /> {post.comment_Count}
                                            </span>
                                            <i className="fa fa-thumbs-up" /> {post.like_Count}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
            {recordCount > pageSize && (
                <div className="text-center mt10">
                    <Paging
                        page={page}
                        narrow={item.w < 3}
                        pageSize={pageSize}
                        recordCount={recordCount}
                        goToPage={setPage}
                    />
                </div>
            )}
        </div>
    );

    return (
        <WidgetBase
            filters={null}
            chart={chart}
            item={item}
            id={`home-${item.ref}`}
            help={item.help}
            hideConfig
            extra={item.extra}
            loading={loading}
        />
    );
};

export default LatestBlogPosts;
